import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// Env
import { environment } from 'src/environments/environment';

// Utils
import { api } from '../utils/api';
import { constants } from '../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {
  // API
  private DOC_TYPES_URL =
    environment.API_URL + api.translator.getIdentificationTypes;

  public docTypes = []

  constructor(private httpClient: HttpClient) { }

  public getDocTypes(): Observable<any> {
    if (this.docTypes.length > 0) {
      return of(this.docTypes);
    }
    return this.httpClient.get(this.DOC_TYPES_URL).pipe(
      map((resp: any) => {
        this.docTypes = resp.content
          .filter((docType: any) => docType.mnemonic !== "RUC")
          .map((docType: any) => {
            return {
              name: docType.shortDesc,
              value: docType.mnemonic,
            };
          });
        return this.docTypes;
      }),
      catchError((err) => {
        throw constants.alerts.default;
      })
    );
  }
}
